/*
   å·¦è¾¹å¯¼èª 'ecp-nav-bar' v1.2
*/
import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {Router} from '@angular/router';

@Component({
  selector: 'ecp-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
  animations: [
    trigger('displayState', [
      state('none', style({
        height: 0, display: 'none', opacity: '0',
      })),
      state('block', style({
        height: '*', display: 'block', opacity: '1',
      })),
      transition('none => block', animate('100ms linear')),
      transition('block => none', animate('100ms linear'))
    ])
  ]
})
export class NavBarComponent implements OnInit {
  @Input() customScaling: boolean;// èªå®ä¹ä¼¸ç¼©,true å¯ä»¥ç¼©æ¾ï¼false ç¦æ­¢ç¼©æ¾
  @Input() customStyle: object = {};
  @Input() navJson: Array<any> = [];
  @Output() goTo = new EventEmitter();
  menuStatus: string = 'off';
  hoverId: number = 0; // å½åå·²éä¸­
  selectId: number = 0; // å½åé¼ æ éä¸­
  thisMenuId: number = 0; // å½åéä¸­å­èå
  hisHover: number = 0; // åå²éä¸­èå,æ¶ç¼©æ¶è®°å½ï¼å±å¼æ¶ä½¿ç¨


  /*

    menus: Array<any> = [
      {
        'name': 'åºæ¬ç»ä»¶',
        'uri': '',
        'iconuri': 'pipe_area',
        'child': [
          {
            'name': 'å·¦è¾¹å¯¼èª',
            'uri': 'navBarPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡¶é¨å¯¼èª',
            'uri': 'topNavPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢å·¦è¾¹å¯¼èª',
            'uri': 'pageLeftNavPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å¼å³åæ¢',
            'uri': 'switchPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¢åå±',
            'uri': 'breadCrumbPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'æ­¥éª¤æ¡',
            'uri': 'stepsInfo',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å·¥å·æ¡',
            'uri': 'toolBarPage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'æç´¢æ¨¡å',
            'uri': 'seachModulePage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'å¼¹åºè¯¦æ',
            'uri': 'openDetailsInfo',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'å¼¹åºè¯¦æ2',
            'uri': 'openDetailsInfo2',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å°å¾ç¨ç»ä»¶',
            'uri': 'dotRipplePage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ä¾§è¾¹æ å¼¹åº',
            'uri': 'popupSidebarPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'æ ç­¾é¡µ',
            'uri': 'tabsPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ç¶ææ¡',
            'uri': 'statusBarPage',
            'iconuri': '',
            'child': null
          }

        ]
      },
      {
        'name': 'å¸å±ç»ä»¶',
        'uri': '',
        'iconuri': 'pipe_area',
        'child': [
          {
            'name': 'å¸å±æ¼ç¤º',
            'uri': 'layoutDemoPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ä¸ä¸­ä¸',
            'uri': 'flexTopCenterBottom',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å·¦ä¸­å³',
            'uri': 'flexleftCenterRight',
            'iconuri': '',
            'child': null
          }
        ]
      },
      {
        'name': 'æ°æ®å±ç¤º',
        'uri': '',
        'iconuri': 'pipe_area',
        'child': [
          {
            'name': 'ç»å½çé¢',
            'uri': 'loginPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'ç³»ç»åæ¢',
            'uri': 'homePage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢æ¼ç¤º1',
            'uri': 'pageDemo',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢æ¼ç¤º3',
            'uri': 'pageDemo3',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'é¡µé¢æ¼ç¤º2',
            'uri': 'detailsStyle1',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'è¡¨æ ¼å±ç¤º1',
            'uri': 'dataDemoPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'è¡¨æ ¼å±ç¤º',
            'uri': 'tablePage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'å¾æ æ¼ç¤º',
            'uri': 'iconPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'æ ç­¾é¡µï¼ä¼ éæ¨¡æ¿ï¼',
            'uri': 'ecpTabset',
            'iconuri': '',
            'child': null
          },
          {
            'name': '404/500é¡µé¢',
            'uri': 'httpPage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'çæå¸å',
            'uri': 'generateBillPage',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'å¼¹çªæ¼ç¤º',
            'uri': 'waterConsumptionAnalysisPopup',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'ç»ä»¶èå¨',
            'uri': 'pageDemo2',
            'iconuri': '',
            'child': null
          },
          {
            'name': 'è°åº¦ä¸­å¿',
            'uri': 'dispatchPage',
            'iconuri': '',
            'child': null
          }
          ,
          {
            'name': 'æ§å¶å°ä¸»é¡µ',
            'uri': 'consolePage',
            'iconuri': '',
            'child': null
          }
        ]
      },
      {
        'name': 'å³äº',
        'uri': 'about',
        'iconuri': 'pipe_report',
        'child': []
      }
    ];

  */

  constructor(private router: Router) {
  }

  ngOnInit() {
    if (this.customScaling == null) {
      this.customScaling = true;
    }
  }

  // èåéä¸­
  hoverMenu(id) {
    if (this.hoverId === id) {
      this.hoverId = null;
    } else {
      this.hoverId = id;
    }
  }

  // ç§»ä¸å»ç
  selectMenu(id) {
    this.selectId = id;

  }

  // æ¸é¤éä¸­
  cleanSel() {
    this.selectId = null;
  }

  // å±å¼
  on() {
    const self = this;
    if (self.menuStatus === 'off') {
      self.hoverId = self.hisHover;

      self.menuStatus = 'on';

    }
  }

  // æ¶ç¼©
  off() {
    const self = this;
    self.hisHover = self.hoverId;
    if (self.customScaling == true) {
      this.menuStatus = 'off';
    }
  }

  showChildMenu(i) {
    if (i === this.hoverId && this.menuStatus === 'on') {
      return 'block';
    } else {
      return 'none';
    }
  }


  selectedApp(uri, hoverId) {
    const self = this;
    this.goTo.emit(uri);
    if (hoverId == null || hoverId == '') {
      self.thisMenuId = 0;
    }
    self.thisMenuId = hoverId;
    // console.log('click');
    // self.router.navigate([uri]);
    return false;
  }


}
